(function () {
  function bindRevealButtons(root) {
    const buttons = (root || document).querySelectorAll(".notification-signup-toggle");
    buttons.forEach((button) => {
      if (button.dataset.notifyRevealBound === "true") {
        return;
      }
      button.dataset.notifyRevealBound = "true";
      button.addEventListener("click", function () {
        const form = button.closest(".notification-signup-form");
        const panel = form ? form.querySelector(".notification-signup-panel") : null;
        const emailInput = panel ? panel.querySelector('input[type="email"]') : null;

        if (!panel) {
          return;
        }

        panel.hidden = false;
        button.hidden = true;
        button.setAttribute("aria-expanded", "true");
        if (emailInput) {
          emailInput.focus();
        }
      });
    });
  }

  function bindForms(root) {
    const forms = (root || document).querySelectorAll(".notification-signup-form");
    forms.forEach((form) => {
      if (form.dataset.notifyBound === "true") {
        return;
      }
      form.dataset.notifyBound = "true";
      form.addEventListener("submit", onSubmit);
    });
  }

  async function onSubmit(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const endpoint = form.dataset.endpoint || "";
    const targetType = form.dataset.targetType || "";
    const targetLabel = form.dataset.targetLabel || "";
    const targetValue = form.dataset.targetValue || "";
    const productGid = form.dataset.productGid || "";
    const emailInput = form.querySelector('[name="email"]');
    const messageNode = form.querySelector(".notification-signup-message");
    const submitButton = form.querySelector('button[type="submit"]');

    if (!endpoint || !emailInput || !submitButton) {
      return;
    }

    setMessage(messageNode, "", "");
    submitButton.disabled = true;

    const payload = {
      email: emailInput.value,
      target_type: targetType,
      target_label: targetLabel,
    };

    if (targetType === "product") {
      payload.product_gid = productGid;
      payload.target_key = productGid;
    } else {
      payload.target_value = targetValue;
    }

    try {
      const response = await fetch(endpoint.replace(/\/+$/, "") + "/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (!response.ok || !data.ok) {
        throw new Error(data.error || "Request failed.");
      }

      if (emailInput.type === "email") {
        emailInput.value = "";
      }
      if (data.status === "already_subscribed") {
        setMessage(messageNode, "You are already subscribed to this alert.", "success");
      } else {
        setMessage(messageNode, "You are subscribed. We will email you when it matches.", "success");
      }
    } catch (error) {
      setMessage(messageNode, error.message || "Something went wrong. Please try again.", "error");
    } finally {
      submitButton.disabled = false;
    }
  }

  function setMessage(node, text, status) {
    if (!node) {
      return;
    }
    node.textContent = text;
    node.dataset.status = status || "";
  }

  document.addEventListener("DOMContentLoaded", function () {
    bindRevealButtons(document);
    bindForms(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    bindRevealButtons(event.target);
    bindForms(event.target);
  });
})();
